import {
  MULTICURRENCY_BANKS,
  MULTICURRENCY_RECHARGE,
  MULTICURRENCY_PAYCONFIRM
} from "../apis/payment";

import { Base64 } from "js-base64";
var payScript;

export default {
  data() {
    return {
      query_timer: 0,
      query_pay_num: 0
    };
  },
  methods: {
    loadScriptSdk(type, success) {
      let _script = { src: "", sdk: null };
      if (type === "AnglPay") {
        _script.sdk = "gr4vy";
        _script.src = "https://cdn.anglpay.gr4vy.app/embed.latest.js";
      }
      if (_script.sdk && !window[_script.sdk]) {
        payScript = window.document.createElement("script");
        payScript.src = _script.src;
        payScript.onload = () => {
          console.log("payScript 加载完成");
          success && success();
        };
        var head =
          window.document.head ||
          window.document.getElementsByTagName("head")[0] ||
          window.document.documentElement;
        head.insertBefore(payScript, head.firstChild);
      } else {
        console.log("payScript 已加载");
        success && success();
      }
    },
    // 获取支付银行列表
    async multicurrencyBanks(paymentId) {
      const query = { paymentId };
      const headers = { headers: { "Content-Type": "application/json;" } };
      const data = await this.$Request(
        "POST",
        MULTICURRENCY_BANKS,
        query,
        headers
      );
      return data.data || data;
    },
    // 多货币支付方式
    onMulticurrencyPayment(param, callback) {
      this.MulticurrencyRecharge(param, callback);
    },
    /** 多货币充值方式
     * https://app.apifox.com/link/project/1121455/apis/api-265418758
     */
    async MulticurrencyRecharge(param, callback) {
      try {
        let rechargeType = "balance";
        if (this.payType === "PO") rechargeType = "pay";
        if (this.payType === "VIP") rechargeType = "vip";
        if (this.Query && this.Query.paymentWay.includes("PAYMENT")) {
          // rechargeType = "preAuth";
        }
        const query = {
          ...param,
          paymentId: this.pId,
          amount: this.price || "",
          rechargeType: rechargeType,
          userOpenId: this.user.p_openID,
          rentNow: rechargeType === "balance",
          qrCode: this.qrcode || this.$route.query.cabinetID || ""
        };
        const headers = {
          headers: { "Content-Type": "application/json;charset=UTF-8" }
        };
        this.$loading(true);
        const { data = {} } = await this.$Request(
          "POST",
          MULTICURRENCY_RECHARGE,
          query,
          headers
        );
        const Payment = this.selectPayment || { paymentMethodType: "" };
        if (data.outTradeNo && Payment.paymentMethodType.includes("Alipay")) {
          this.queryPaymentConfirm(data, callback);
          window.location.href = data.paymentInfo.payUrl;
          return false;
        }
        if (data.outTradeNo && data.approvalUrl) {
          window.location.href = data.approvalUrl;
          return false;
        }
        if (data.outTradeNo && data.paymentType.includes("BncEnLinea")) {
          await this.MulticurrencyConfirm(data.outTradeNo, "");
          callback && callback(data);
          this.$loading(false);
          return false;
        }
        throw new Error(data.message);
      } catch (err) {
        this.$loading(false);
        this.$toast(err);
        console.warn("Multicurrency ~ err:", err);
      }
    },
    // 多货币确认支付方式
    async MulticurrencyConfirm(outTradeNo, tradeNo) {
      const query = { outTradeNo: outTradeNo || "", tradeNo: tradeNo || "" };
      const res = await this.$Request("GET", MULTICURRENCY_PAYCONFIRM, query);
      return res.data || res;
    },
    // 查询支付确认
    async queryPaymentConfirm(Payment, callback) {
      if (this.query_pay_num > 12) {
        clearTimeout(this.query_timer);
        this.query_pay_num = 0;
        return false;
      }
      const callbackCell = result => {
        if (result && result.orderStatus === 1) {
          this.$loading(false);
          callback && callback(Payment);
        } else {
          this.query_pay_num++;
          this.query_timer = setTimeout(() => {
            this.queryPaymentConfirm(Payment, callback);
          }, 2200);
        }
      };
      if (Payment.outTradeNo) {
        await this.MulticurrencyConfirm(Payment.outTradeNo, Payment.tradeNo)
          .then(result => {
            callbackCell(result);
          })
          .catch(res => {
            callbackCell(res);
          });
      }
    },
    onBncEnLineaPayent(param) {
      const { bncCardInfo } = this.$store.state;
      if (!Object.keys(bncCardInfo).length) return;
      let paymentType = "BncEnLinea_P2P";
      if (bncCardInfo.CVV) {
        paymentType = "BncEnLinea_VPOS";
      } else {
        bncCardInfo["Amount"] = this.price;
      }
      const item = this.payModeList.find(v => (v.pPaymentType === paymentType && !(v.paymentConfig && v.paymentConfig.pId)));
      if (item && item.pId) {
        this.pId = item.pId;
        this.payMode = item.pPaymentType;
      }
      const jsonString = Base64.encode(JSON.stringify(bncCardInfo));
      console.log("🚀 ~ bncCardInfo:", bncCardInfo);
      const paymentInfo = { payUserInfo: jsonString };
      this.$store.commit("bncCardInfo", {});
      this.MulticurrencyRecharge(paymentInfo, res => {
        this.checkOrder(res.outTradeNo);
      });
    },
    /**
     * 卡支付信息
     */
    onSaveCardPay(param = {}) {
      if (param.hasOwnProperty("show")) {
        this.saveCardPayDialog = param.show;
      }
      if (param.cancel) return;
      const _card = { ...param };
      delete _card.show;
      if (this.payMode && this.payMode.includes("BncEnLinea")) {
        // 1. JSON 编码 - Base64 编码（js-base64 自动处理 UTF-8）
        _card.DebtorBankCode = parseInt(_card.DebtorBankCode);
        const jsonString = Base64.encode(JSON.stringify(_card));
        const paymentInfo = { payUserInfo: jsonString };
        this.MulticurrencyRecharge(paymentInfo, res => {
          this.checkOrder(res.outTradeNo);
        });
      }
    }
  }
};
